import React from 'react';


const BrandHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="relative">
          {/* Main logo container */}
          <div className="w-16 h-16 rounded-xl flex items-center justify-center relative overflow-hidden">
            <img 
              src="/assets/images/big_logo_black-1767417875469.png" 
              alt="MyDojo Logo" 
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>

      {/* Brand Name */}
      <h1 className="text-3xl font-bold text-foreground mb-2">
        MyDojo
      </h1>
      
      {/* Tagline */}
      <p className="text-muted-foreground text-sm font-medium">
        Academy Management System
      </p>
      
      {/* Subtitle */}
      <p className="text-muted-foreground text-xs mt-1">
        Secure access for academy staff and students
      </p>
    </div>
  );
};

export default BrandHeader;